export default {
    intro: '将打乱的句子按正确顺序排列吧！',
    indicator: ({ values }: { values: { isAllDone: boolean } }) => {
        const { isAllDone } = values;
        if (isAllDone) {
            return '请再次阅读完成的文章。';
        }
        return '请将句子按正确顺序排列！';
    },
    retry: ({ values }: { values: { count: number } }) =>
        `差一点！还有 ${values.count} 个句子位置不对。还有一次机会，再试一次吧！`,
    exhausted: '来看看正确答案吧！下次一定能做对的。',
    viewCompleted: '查看完成的文章',
    table: { question: '题目', answerRate: '正确率', emptyMessage: '没有内容。' },
    roundNumber: '第{number}题',
};
